module.exports = __webpack_public_path__ + "img/vuma-fibre-process-2.3ad9c8d0.svg";